import { Style } from "@portal/lib/style/style";

export const StyledFilterStrip = Style("div", {
  padding: "var(--space-16) 120px",
  backgroundColor: "var(--geekblue-1)",
  boxShadow: "var(--shadow-1), var(--shadow-1)",
  width: "100%",
  borderRadius: 0,
  height: "auto",
  minHeight: "64px",
  marginBottom: "var(--space-24)",

  variants: {
    layout: {
      l1: {
        display: "grid",
        gridTemplateColumns: "var(--gridW) auto",
        gap: "var(--space-12)",
        alignItems: "start",
      },
      l2: {
        display: "grid",
        alignItems: "center",
      },
    },
  },
});
